import PropTypes from "prop-types";

const SearchBox = ({ style_name = "", placeholder, onChange, value = "" }) => {
  return (
    <div className={`gx-search-bar ${style_name}`}>
      <div className="gx-form-group">
        <input
          className="ant-input"
          type="search"
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
        <span className="gx-search-icon gx-pointer">
          <i className="icon icon-search" />
        </span>
      </div>
    </div>
  );
};
export default SearchBox;

SearchBox.propTypes = {
  style_name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};
